module.exports = __webpack_public_path__ + "static/media/client-report-icon-active.a58ca2ec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/client-report-icon-active.svg
// module id = 1022
// module chunks = 1